var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"switch-bar"},_vm._l((_vm.data),function(tab,i){return _c('div',{key:i,staticClass:"tab",class:{ active: _vm.tabIndex === i },on:{"click":function($event){return _vm.changeTab(i, tab)}}},[_c('span',[_vm._v(_vm._s(tab.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }